import { useState, useEffect } from 'react'
import { Grid, Radio } from '@mui/material'

import Dialog from './Dialog'
import DatePicker from './DatePicker'
import TimePicker from './TimePicker'
import GridMatchInfo from './GridMatchInfo'
import { titlesCalendari } from '../settings/settings'

const availableFunctions = ['sposta', 'inverti', 'rimanda']

const DialogCalendario = ({ open, handleClose, triggerFunction, gara }) => {
  const [selectedFunction, setSelectedFunction] = useState()
  const [newData, setNewData] = useState()
  const [newOra, setNewOra] = useState()
  const [swapTeams, setSwapTeams] = useState()

  if (!selectedFunction) setSelectedFunction(availableFunctions[0])

  useEffect(() => {
    setNewData()
    setNewOra()
    setSwapTeams(selectedFunction === availableFunctions[1])
  }, [selectedFunction])

  useEffect(() => {
    setSelectedFunction()
    setNewData()
    setNewOra()
    setSwapTeams()
  }, [open])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(newData, newOra, swapTeams)}
      title={titlesCalendari.titleEditCalendario}
      textConfirm='Salva'
      maxWidth='md'
    >
      <GridMatchInfo gara={gara}>
        <Grid container alignItems='center' sx={{ width: '100%' }}>
          <Grid size={{ xs: 2, md: 1 }}>
            <center>
              <Radio
                id={availableFunctions[0]}
                value={availableFunctions[0]}
                checked={selectedFunction === availableFunctions[0]}
                onChange={event => setSelectedFunction(event.target.value)}
              />
            </center>
          </Grid>
          <Grid size={{ xs: 10, md: 4 }}>Cambio data e ora...</Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <center>
              <DatePicker
                label='Data'
                value={newData}
                onChange={setNewData}
                disabled={selectedFunction !== availableFunctions[0]}
              />
            </center>
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <center>
              <TimePicker
                label='Ora'
                value={newOra}
                onChange={setNewOra}
                disabled={selectedFunction !== availableFunctions[0]}
              />
            </center>
          </Grid>
        </Grid>
        <Grid container alignItems='center' sx={{ width: '100%' }}>
          <Grid size={{ xs: 2, md: 1 }}>
            <center>
              <Radio
                id={availableFunctions[1]}
                value={availableFunctions[1]}
                checked={selectedFunction === availableFunctions[1]}
                onChange={event => setSelectedFunction(event.target.value)}
              />
            </center>
          </Grid>
          <Grid size={{ xs: 10, md: 4 }}>Inversione di campo.</Grid>
        </Grid>
        <Grid container alignItems='center' sx={{ width: '100%' }}>
          <Grid size={{ xs: 2, md: 1 }}>
            <center>
              <Radio
                id={availableFunctions[2]}
                value={availableFunctions[2]}
                checked={selectedFunction === availableFunctions[2]}
                onChange={event => setSelectedFunction(event.target.value)}
              />
            </center>
          </Grid>
          <Grid size={{ xs: 10, md: 4 }}>Rinvio a data da destinarsi.</Grid>
        </Grid>
      </GridMatchInfo>
    </Dialog>
  )
}

export default DialogCalendario
